import { gql } from "@/services/httpAdapter";

export const ON_UPDATE_TRANSFER_REQUEST_STATUS_FROM_INVENTORY = gql`
	subscription onUpdateTransferRequestStatusFromInventory($locationId: String, $payPeriodId: String) {
		onUpdateTransferRequestStatusFromInventory(locationId: $locationId, payPeriodId: $payPeriodId) {
			_id
			locationId
			payPeriodId
			stockNumber
			vinNumber
			make
			model
			trim
			colorExterior
			year
			requestedByLocationId
			requestedDate
			approvedDate
			isBlocked
			approvedBy {
				userId
				fullName
			}
			requestStatus
			rejectReason
			transferType
		}
	}
`;

export const onToggleDealerTradeBlockByLocation = gql`
	subscription onToggleDealerTradeBlockByLocation($locationId: String!) {
		onToggleDealerTradeBlockByLocation(locationId: $locationId) {
			locationId
		}
	}
`;

export const onSendConsumerRegistrationUpdated = gql`
	subscription onSendConsumerRegistrationUpdated($locationId: String!) {
		onSendConsumerRegistrationUpdated(locationId: $locationId) {
			locationId
		}
	}
`;
